import { render, staticRenderFns } from "./CreateTransferDialog.vue?vue&type=template&id=72c476fe&scoped=true&"
import script from "./CreateTransferDialog.vue?vue&type=script&lang=js&"
export * from "./CreateTransferDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateTransferDialog.vue?vue&type=style&index=0&id=72c476fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c476fe",
  null
  
)

export default component.exports